var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIceRescue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 59",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "037---Ice-Rescue",
    fill: "none",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 48.41-2-12.41-9.45-12.28c-.3643816-.4660516-.8584219-.8139674-1.42-1l-10.21-3.4c-1.28-.45-1.85-.32-8.92-.32-.8542518.0265355-1.7013954.1643645-2.52.41 1.2863657 2.5397257 2.8276247 4.9420796 4.6 7.17l-3.08.63c-2.8334832-1.6387318-5.3527527-3.768598-7.44-6.29l-12.82 3.22c-.40115156.1054556-.69556029.4476063-.74.86l-.86 9.5-2.14 1.5-1 10.77c-.05175954.7632896.33644474 1.4892316 1 1.87l16.32 9.92c.4697784.2870243 1.0094783.4392473 1.56.44h3.12l7-10v9c0 .5522847.4477153 1 1 1h3.72c.48 0 .13.08 6-2.1.7830654-.3020237 1.2942612-1.06083 1.28-1.9v-6.14l6.12 5.27c.1 0-.11 0 9.58-3.57.8855826-.3210895 1.4270623-1.2166136 1.3-2.15z",
    fill: "#9fc9d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10.71 29.9-6.57 4.6.86-9.5c-.04355133.4154956.1757795.8142789.55 1l5.07 2.22c.2956787.1684196.485422.4756372.5036253.8154308.0182032.3397936-.1376322.6655243-.4136253.8645692z",
    fill: "#84b5cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23 43v16c-3.11 0-3.78.14-4.72-.44l-16.28-9.92c-.66355526-.3807684-1.05175954-1.1067104-1-1.87l1-10.77c10.33 4.26 4.31 1.74 16.45 6.77.74.3.94.23 4.55.23z",
    fill: "#84b5cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m12 40.12v6.88c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-7.7z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m57.7 50.56-9.57 3.57c1.92-16.31 1.87-15.81 1.87-15.91l7-2.22 2 12.41c.1270623.9333864-.4144174 1.8289105-1.3 2.15z",
    fill: "#84b5cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m50 38.23c-.71 5.4-1.78 15.9-1.88 15.9l-6.12-5.27v-8.09z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m50 38.22-8 2.54-1.92-4.39c-.143363-.360515-.0652605-.7714179.200376-1.0541923.2656365-.2827743.670861-.3863808 1.039624-.2658077z",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 40.77v14.23c-.0014585.833286-.5194179 1.5783507-1.3 1.87-5.85 2.18-5.5 2.1-6 2.1h-3.7c-.5522847 0-1-.4477153-1-1v-14.97c4.0990415-.0419389 8.1595538-.7965174 12-2.23z",
    fill: "#84b5cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47.13 6.61c-24.48 9.26-24.08 9.14-24.13 9.14-.69-2.08-2.9-3.65-2.95-4.63-.0494996-.3711428-.0662309-.7459228-.05-1.12l2-.12 23.08-8.7c1.4994531-.56609187 3.1739081.1905469 3.74 1.69s-.1905469 3.17390813-1.69 3.74z",
    fill: "#e64c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 11.12c0-.47 0 .6 0-6.12 0-2.209139-1.790861-4-4-4s-4 1.790861-4 4c0 4.37-.16 5.48.41 8 1.1 4.73 4.92 10.32 11.54 14.21l3.14-.63c-3.28-4.2-6.82-10.17-7.09-15.46zm-4-.12c-.5522847 0-1-.4477153-1-1 0-.55228475.4477153-1 1-1s1 .44771525 1 1c0 .5522847-.4477153 1-1 1zm0-4c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1 1 .44771525 1 1-.4477153 1-1 1z",
    fill: "#464f5d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2980ba"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 29c-.5522847.0552285-1.0447715-.3477153-1.1-.9s.3477153-1.0447715.9-1.1l10-2c.5522847-.1104569 1.089543.2477153 1.2.8.1104569.5522847-.2477153 1.089543-.8 1.2-10.69 2.11-10.05 2-10.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29.18 39.65c-.23.48-.11.56.82 3.35v6l-7 10v-16l1.83-4.57c.108102-.2736609.3312396-.4858246.61-.58l4.41-1.47c.1930042-.0674794.4076469-.0106498.541973.1434949.1343261.1541448.1612675.3745427.068027.5565051z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceRescue);
export default __webpack_public_path__ + "static/media/ice-rescue.339502a74e9bde90662f2e30caea6fee.svg";
export { ForwardRef as ReactComponent };